<template>
  <article>
    <h3>{{ title }}</h3>
    <div class="description">
      <p>{{ description }}</p>
    </div>

    <div class="provider-grid-wrapper">
      <div
        v-for="provider in providers"
        :key="provider.id"
        class="provider-grid-item">
        <router-link
          :to="{ name: 'ProviderDetails', params: { providerId: provider.id }}">
          <h4>{{ provider.companyName }}</h4>
        </router-link>

        <StarRating
          :rating="provider.reviewScore"
          :editable="false"
          :size="20"
          justify="flex-start">
          <template #label>
            <span class="rating-label">{{ reviewCountLabel(provider) }}</span>
          </template>
        </StarRating>
      </div>
    </div>

    <slot name="more-link">
      <router-link
        class="default-btn link"
        :to="{ name: 'ProvidersListByCategory', params: { category }}">
        View More
      </router-link>
    </slot>
  </article>
</template>

<script>
export default {
  name: 'CategorySection',
  props: {
    title: String,
    description: {
      type: String,
      default: '',
    },
    category: String,
    providers: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    reviewCountLabel (provider) {
      const count = provider.reviewCount || 0

      return `(${count} review${count === 1 ? '' : 's'})`
    },
  },
}
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

h3 {
  color: $textDarkMuted;
  font-size: 22px;
  line-height: 24px;
}

h4 {
  color: $textDarkMuted;
  font-size: 16px;
  line-height: 18px;
}

.description {
  p {
    margin: 16px 0 32px;
    color: $textDarkMuted;
  }
}

.provider-grid-item {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 5px;

  a {
    text-decoration: none;
  }
}

.rating-label {
  margin-left: 5px;

  color: #908E8E;
  font-family: "SansationRegular", sans-serif;
  font-size: 14px;
  line-height: 15px;
}
</style>
